import React, { useState } from 'react'

// The URL is submitted as-is and parsed server-side (Event::VideoConcerns),
// which rejects unrecognised links with a validation error instead of
// silently clearing the stored video.
function VideoUrlInput ({
  initialUrl = '',
  name,
  inputId = 'video_url'
}) {
  const [url, setUrl] = useState(initialUrl)

  return (
    <div>
      <label
        htmlFor={inputId}
        className='block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1'
      >
        Video URL
      </label>
      <input
        type='text'
        inputMode='url'
        id={inputId}
        name={name}
        value={url}
        onChange={e => setUrl(e.target.value)}
        placeholder='https://www.youtube.com/watch?v=... or https://vimeo.com/...'
        className='block w-full px-3 py-2 rounded-md border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm'
      />
      <p className='mt-1 text-sm text-gray-600 dark:text-gray-400'>
        Paste a YouTube or Vimeo link. Clear the box to remove the video.
      </p>
    </div>
  )
}

export default VideoUrlInput
